export default __webpack_public_path__ + "d93934e6aa0bbb6895e2dcb58557f1a8.ttf";